import handleFetch from './handleFetch';
import { StoredCard } from './local-storage';
import { RetentionSent } from './session-storage';

type SendRetentionEmailParams = {
  configId: string;
  locale: string;
};

export const sendRetentionEmail = (cardData: SendRetentionEmailParams): Promise<Response | Error> => {
  const data = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': process.env.SAAS_API_KEY || '',
    },
    body: JSON.stringify(cardData),
  };
  return handleFetch(`${process.env.SAAS_EMAIL_RETENTION_ENDPOINT}`, data);
};

export const handleRetentionEmail = (lang: string) => {
  if (`${process.env.RETENTION_EMAIL_ON_SESSION_START}` === 'true') {
    const cardJSON = StoredCard.get();
    const retentionSent = RetentionSent.get();

    if (cardJSON && !retentionSent) {
      const card = JSON.parse(cardJSON);
      sendRetentionEmail({
        configId: card.configId,
        locale: lang === 'es' ? 'es-US' : 'en-US',
      })
        .then(() => RetentionSent.set('true'))
        .catch((err) => {
          RetentionSent.set('false');
          console.warn('Failed to send retention email', err); /* eslint-disable-line no-console */
        });
    }
  }
};
